import { Dict } from "../types";

export const ltrimSlash = (text: string) => text.replace(/^\/+/, "");
export const rtrimSlash = (text: string) => text.replace(/\/+$/, "");

export const createUrl = (path: string, params: Dict<string>): string =>
    path
        .split("/")
        .map((part) => {
            if (!part.startsWith(":")) {
                return part;
            }

            const key = part.slice(1, Infinity);
            return params[key] || part;
        })
        .join("/");
